import { FooterMaximized } from "components/footerfull";
import Header from "components/headerfull";
import Info from '../assets/info_alert.svg';
import InfoW from '../assets/info_alert_w.svg';
import SuccessW from '../assets/success_w.svg';
import Ewallet from '../assets/ewallet.svg';
// import profiles from '../assets/profiles.json';
import CirclePlay from '../assets/circleplay.svg';
import CirclePause from '../assets/circlepause.svg';
import VerticalDots from '../assets/verticaldots.svg';
import Enveloppe from '../assets/enveloppeoutline.svg';
import Location from '../assets/locationoutline.svg';
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Divider, Settings } from "./profil-worker";
import { RoundBluePlain } from "components/ui/Buttons/generic/GenericButton";
import { get } from "services/config";
import { setDescription } from "./accueil";
import { _getProfileWorker } from "services/parcours/freelance.service";


const Profile= () => {
    
    const [modalShown, setModalShown]= useState<boolean>(false);

    const showModal= () => {setModalShown(true)};
    const hideModal= () => {setModalShown(false)};

    const [userData, setUserData]= useState<any>({});

    const history= useNavigate();

    useEffect(()=> {
        document.title= "Votre profil - Wall of Share";
        const desc= "Ici vous pouvez voir vos informations et les modifier au besoin.";
        setDescription(desc);
        if(localStorage.getItem('user')){
            get("/api/freelance/my-profil", {}, {withCredentials: true}).then(response => {

                console.log(response);
                console.log(response.data);
                const data: any= response.data;
                if (data.message === "Freelance datas") {
                    setUserData(response.data);
                } else {
                    history('/plateforme-freelance');
                }

            }).catch(error => {console.log(error)});
        }
    }, []);

    const profile= {//<-still fake data, need update from backend dev.
        iban: 'GB-29-NWBK-601613-31926819',
        delay: 3,
        ewallet: {
            available: false
        }
    };

    return(<>
        <div className="w-full m-0 p-0 max-w-[100vw] overflow-clip">
            <Header type="default"/>
            {modalShown && <TwoStepsModal data={{iban: profile?.iban, balance: userData.data.wallet, delay: profile?.delay}} hideModal={hideModal}/>}
            <Banner />
            <div className="w-full bg-[#f4f4f5] pb-[116px] pt-[30px]">
                {
                    !profile?.ewallet.available
                    &&
                    <div className="md:my-[60px] mb-[30px] max-w-[1140px] w-[90%] bg-[#bbbbc433] lg:px-[60px] px-[40px] py-[30px] flex flex-col gap-[20px] md:flex-row md:items-center justify-center items-start mx-auto rounded-[10px]">
                        <img src={Info} alt="INFO" className="w-[20px] md:w-[30px]"/>
                        <p className="font-dm-sans font-medium md:text-[16px] md:leading-[20.83px] text-[12px] leading-[15.62px] text-primary-blue">Votre fiche d’information est incomplète, si vous souhaitez pouvoir retirer l’argent de votre E-Wallet après avoir réalisé des missions, il est indispensable de remplir votre fiche complètement et de transmettre tous les documents demandés. Rendez-vous dans l’onglet Paramètres.</p>
                    </div>
                }
                <div className="max-w-[1140px] w-[90%] flex lg:flex-row flex-col items-start gap-[20px] mx-auto">
                    <ProfileSideBar profile={userData.data} showModal={showModal}/>
                    <>
                        {/* Put the main content here */}
                        <MainContent profile={userData.data} />
                    </>
                </div>
            </div>

            <FooterMaximized />
        </div>
    </>);
};

const TwoStepsModal= ({data, hideModal}: {data: {iban: string, balance: number, delay: number}, hideModal: ()=> void}) => {
    const doNothing= (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const [step, setStep]= useState(1);

    const confirmPay= (e: any) => {
        //logic for transfering money or whatever
        setStep(2);
    };


    return <>
    {
        step=== 1 ?
        <div className="fixed w-full top-0 left-0 right-0 bottom-0 bg-[#1d1d39aa] flex flex-column items-center justify-center z-[30]" onClick={hideModal}>
            <div className="w-[320px] bg-primary-blue rounded-[20px] flex flex-col gap-[10px] px-[30px] py-[24px]" onClick={doNothing}>
                <img src={InfoW} alt="INFO" width={"20"} height={"20"} className="w-[20px] h-[20px]"/>
                <p className="text-[12px] leading-[14.4px] text-white font-normal">
                    Vous êtes sur le point de retirer {data.balance}€ sur votre compte bancaire.<br/>
                    IBAN : {data.iban}<br/>
                    Êtes-vous sur de vouloir retirer votre argent ?
                </p>
                <div className="flex flex-row gap-[5px]">
                    <RoundBluePlain isButton={true} className="px-[10px] py-[5px] text-[12px] leading-[15.62px] font-semibold" text="Retirer mon argent" onClick={confirmPay}/>
                    <button className="px-[10px] py-[5px] text-[12px] leading-[15.62px] font-semibold text-white bg-[#ffffff22] rounded-full hover:bg-[#ffffff55]" onClick={hideModal}>Annuler</button>
                </div>
            </div>
        </div>
        :
        <div className="fixed w-full top-0 left-0 right-0 bottom-0 bg-[#1d1d39aa] flex flex-column items-center justify-center z-[30]" onClick={hideModal}>
            <div className="w-[320px] bg-primary-blue rounded-[20px] flex flex-col gap-[10px] px-[30px] py-[24px]" onClick={doNothing}>
                <img src={SuccessW} alt="INFO" width={"20"} height={"20"} className="w-[20px] h-[20px]"/>
                <p className="text-[12px] leading-[14.4px] text-white font-normal">
                    Félicitations ! Votre demande a été validée. L'argent du E-wallet est en cours de transfert vers votre compte. Le montant sera visible sur votre compte dans {data.delay} jours.
                </p>
                <div className="flex flex-row gap-[5px]">
                    <RoundBluePlain isButton={true} className="px-[10px] py-[5px] text-[12px] leading-[15.62px] font-semibold" text="Retourner sur ma fiche" onClick={hideModal}/>
                </div>
            </div>
        </div>
    }
    </>;
};

export const BigWhiteButton= ({active= true, onClick, text="Retirer mon argent", cString=""}: {active?: boolean, onClick: ()=> void, text?: string, cString?: string}) => {
    let cName="py-[9px] flex items-center justify-center w-full text-[16px] leading-[20.83px] font-semibold font-dm-sans bg-white text-primary-blue rounded-full ";
    cName+= active ? " cursor-pointer hover:bg-[#ffffff66] transition duration-300" : " opacity-[10%] cursor-not-allowed";
    cName+= cString;
    return <>
        <button disabled={!active} className={cName} onClick={onClick}>{text}</button>
    </>;
};

const TooltipGimmick= ({id, text=""}: {id: string, text?: string}) => {

    const [tooltipShown, setTooltipShown]= useState<boolean>(false);
    const toggleTooltip= (event: any) => {
        event.preventDefault();
        setTooltipShown(v=> !v);
    };
    useEffect(()=> {
        const clickDoc= (event: any) => {
            if(!event.target.closest('#wos-ewallet-tooltip')&&!event.target.closest('#' + id)){
                setTooltipShown(false);
            }
        };
        document.body.addEventListener('click', clickDoc);
        return(()=> {
            document.body.removeEventListener('click', clickDoc);
        });
    }, []);

    return <>
        {
            tooltipShown &&
            <div className="absolute p-[21px] bg-white text-[#6f6f6f] text-[12px] leading-[15.62px] font-normal font-dm-sans w-[202px] rounded-[10px] border-[1px] border-[#c4c4c4] md:top-[-20px] top-[50%] right-0 md:transform md:translate-x-[50%]" id="wos-ewallet-tooltip" style={{zIndex: "8", whiteSpace: "pre-wrap"}}>{text}</div>
        }
        <img src={InfoW} alt="INFO" className="opacity-[1] transition duration-300 hover:opacity-[.5] cursor-pointer" onClick={toggleTooltip} id={id} />
    </>;
};

const ProfileSideBar= ({profile, showModal}: {profile: any, showModal: ()=> void}) => {

    /* Fake DATA */
    const availabilityOfEwalletDate= "10/02/2025";
    // const fakeSound= ["https://wall-of-share.com/web/content/26341"];

    return<>
        <div className="w-full lg:max-w-[378px] max-w-[500px] rounded-[10px] bg-white shrink-0">
            <div className="w-full bg-primary-blue md:px-[30px] px-[26.5px] py-[30px] rounded-t-[10px] flex flex-row max-[390px]:flex-col gap-[13px]">
                <div className="w-[109px] h-[120px] shrink-0 bg-cover bg-center bg-norepeat overflow-hidden rounded-[8px]" style={{backgroundImage: `url("${profile?.image}")`}}>
                    <img src={profile?.image} alt="Photo de profil" className="object-cover opacity-0 max-w-[unset]"/>
                </div>
                <div className="w-full flex flex-col gap-[10px]">
                    <div className="w-full flex flex-col gap-[5px]">
                        <h2 className="text-[40px] leading-[48px] font-semibold text-white">{profile?.firstname}</h2>
                        <div className="text-[20px] leading-[24px] font-light text-white">{profile?.lastname}</div>
                    </div>
                    <div className="rounded-[5px] bg-[#ffffff07] px-[10px] py-[5px] text-[16px] leading-[16px] font-light text-white">{profile?.fav_domain}</div>
                </div>
            </div>

            <div className="w-full relative" style={{backgroundImage: "linear-gradient(180deg, #1d1d39 0%, #1d1d39 33%, #ffffff 33%, #ffffff 100%)"}}>

                <div className="mx-auto bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 rounded-[10px] max-w-[320px] w-[90%] flex flex-col gap-[12px] px-[24px] py-[21px] text-white">
                    <div className="flex gap-[12px]">
                        <img src={Ewallet} alt="EWALLET" />
                        <div className="text-[22px] leading-[22px] font-semibold">Mon E-Wallet</div>
                    </div>
                    <div className="flex flex-col gap-[10px]">
                        <div className="flex items-center gap-[10px]">
                            <div className="md:text-[35px] md:leading-[35px] text-[30x] leading-[30px] font-normal">{profile?.available_wallet} €</div>
                            {
                                // !profile?.ewallet.available &&
                                <div className="bg-[#ffffff10] rounded-[10px] text-[14px] leading-[16.8px] font-normal py-[5px] px-[7px] max-w-[104px]">Disponibe le {profile?.available_at}</div>
                            }
                        </div>
                        <div className="flex gap-[7px]">
                            <div className="text-white font-normal text-[12px] leading-[100%]">Mise en garantie : {profile?.wallet_guarantee || 0}€</div>
                            <TooltipGimmick id="wos-info-1" text={"« Mise en garantie »\nFonds temporairement bloqués\nCe montant correspond à des fonds mis en attente par mesure de sécurité. Ils peuvent être liés à une mission en cours, à une période de validation, ou à une vérification exceptionnelle. Ces sommes seront automatiquement libérées une fois les conditions remplies."}/>
                        </div>
                        <div className="flex gap-[7px]">
                            <div className="text-white font-normal text-[12px] leading-[100%]">A venir : {profile?.draft_wallet}€</div>
                            <TooltipGimmick id="wos-info-2" text={"« À venir »\nRevenus en cours de traitement\nIl s’agit des gains déjà générés mais non encore disponibles. Ils sont en attente de validation par le client ou en cours de transfert. Le montant sera ajouté à votre solde dès qu’il sera confirmé."}/>
                        </div>
                    </div>
                    <BigWhiteButton active={(profile?.wallet > 0)} onClick={showModal}/>
                </div>

            </div>

            <div className="mt-[17px] flex flex-col gap-[30px] md:px-[30px] px-[22px] pb-[22px]">
                <h3 className="text-[20px] leading-[20px] font-semibold text-primary-blue">Aperçu du profil</h3>
                <div className="flex flex-col gap-[15px] border-b-[#f4f4f5] border-b-[1px] pb-[30px]">
                    <div className="flex flex-row max-[390px]:flex-col max-[390px]:items-start max-[390px]:gap-[10px] justify-between items-center w-full">
                        <div className="text-[#6f6f6f] leading-[13px] text-[13px] font-light">Date de mise à jour</div>
                        <div className="text-primary-blue text-[16px] leading-[19.2px] font-semibold">{availabilityOfEwalletDate}</div>
                        {/* <div className="text-primary-blue text-[16px] leading-[19.2px] font-semibold">{SQLtoJSfr(profile?.lastupdate)}</div> */}
                    </div>

                    <div className="flex flex-row max-[390px]:flex-col max-[390px]:items-start max-[390px]:gap-[10px] justify-between w-full">
                        <div className="text-[#6f6f6f] leading-[13px] text-[13px] font-light">Domaine(s)</div>
                        <ul className="text-primary-blue text-[16px] leading-[19.2px] font-semibold flex flex-col gap-[8px] items-end max-[390px]:items-start list-none">
                            {profile?.expertise_list?.map((obj: any) => obj.category_id).filter((category: any, index: any, arr: any) => arr.indexOf(category) === index).map((domain: any, index: number)=>(
                                <li className={domain.length<23? "w-max" : "w-max text-[14px]"} key={"domaine-" + index}>{domain}</li>
                            ))}
                        </ul>
                    </div>

                    <div className="flex flex-row max-[390px]:flex-col max-[390px]:items-start max-[390px]:gap-[10px] justify-between items-center w-full">
                        <div className="text-[#6f6f6f] leading-[13px] text-[13px] font-light">Prix</div>
                        <div className="text-white text-[16px] leading-[19.2px] font-normal bg-primary-blue px-[10px] py-[7px] rounded-[5px]">{profile?.rate}€<span className="text-[10px] leading-[12px]">/mois</span></div>
                    </div>

                    <div className="flex flex-row max-[390px]:flex-col max-[390px]:items-start max-[390px]:gap-[10px] justify-between w-full">
                        <div className="text-[#6f6f6f] leading-[13px] text-[13px] font-light">Langue(s)</div>
                        <ul className="text-primary-blue text-[16px] leading-[19.2px] font-semibold flex flex-col gap-[8px] items-end max-[390px]:items-start list-none">
                            {profile?.lgs?.map((language: any, index: number)=>(
                                <li className={language.length<23? "w-max" : "w-max text-[14px]"} key={"langue-" + index}>{language}</li>
                            ))}
                        </ul>
                    </div>

                    <div className="flex flex-row max-[390px]:flex-col max-[390px]:items-start max-[390px]:gap-[10px] justify-between items-center w-full">
                        <div className="text-[#6f6f6f] leading-[13px] text-[13px] font-light">Âge</div>
                        <div className="text-primary-blue text-[16px] leading-[19.2px] font-semibold">{profile?.age} ans</div>
                    </div>

                    <div className="flex flex-row max-[390px]:flex-col max-[390px]:items-start max-[390px]:gap-[10px] justify-between items-center w-full">
                        <div className="text-[#6f6f6f] leading-[13px] text-[13px] font-light">Écouter ma présentation</div>
                        <div className="text-[#6f6f6f] text-[16px] leading-[19.2px] font-normal bg-[#1d1d3922] px-[10px] py-[7px] rounded-[5px] flex flex-row gap-[10px]">
                            <AudioPlayer audioPath={profile?.audio_url || [null]}/>
                            {/* <AudioPlayer audioPath={fakeSound || [null]}/> */}
                            {/* <AudioPlayer audioPath={["http://wall-of-share.com/web/content/25721"]}/> // <- An URL for testing DO NOT DELETE*/}
                        </div>
                    </div>

                    <div className="flex flex-row max-[390px]:flex-col max-[390px]:items-start max-[390px]:gap-[10px] justify-between items-center w-full">
                        <div className="text-[#6f6f6f] leading-[13px] text-[13px] font-light">Pays</div>
                        <div className="text-primary-blue text-[16px] leading-[19.2px] font-semibold">{profile?.country_id}</div>
                    </div>
                </div>
                <h3 className="text-[20px] leading-[20px] font-semibold text-primary-blue">Contact Wall of Share</h3>
                <div className="flex flex-col gap-[15px]">
                    <div className="flex flex-row max-[390px]:flex-col justify-between">
                        <div className="flex gap-[5px] items-center">
                            <div className="p-[10px] rounded-full bg-[#f4f4f5]"><img src={Enveloppe} alt="ENVELOPPE" /></div>
                            <div className="text-[#6f6f6f] text-[13px] leading-[13px] font-light">Email</div>
                        </div>
                        <div className="text-primary-blue text-[16px] leading-[19.2px] font-semibold">contact@wall-of-share.com</div>
                    </div>
                    <div className="flex flex-row max-[390px]:flex-col justify-between">
                        <div className="flex gap-[5px] items-center">
                            <div className="p-[10px] rounded-full bg-[#f4f4f5]"><img src={Location} alt="LOCATION" /></div>
                            <div className="text-[#6f6f6f] text-[13px] leading-[13px] font-light">Adresse</div>
                        </div>
                        <div className="text-primary-blue text-[16px] leading-[19.2px] font-semibold w-min">198 avenue de Verdun, 92130 Issy les Moulineaux</div>
                    </div>
                </div>
            </div>
        </div>
    </>;
};

/**
 * Converts a number into a string mm:ss readable format
 * Ex: 75 becaomes 1:15, 65 becomes 1:05
 * @param secAsFloat number
 * @returns string
 */
const secondsToMin= (secAsFloat: number) => {
    const sec= Math.round(secAsFloat);
    return `${(sec - (sec % 60)) / 60} : ${((sec % 60) < 10) ? '0' : ''}${sec % 60}`;
};

const AudioPlayer= ({audioPath}: {audioPath: Array<any>}) => {

    const thePlayer= useRef<HTMLAudioElement>(null);
    const [isPLaying, setIsPlaying]= useState<boolean>(false);

    const playPause= (event: any) => {
        event.preventDefault();
        if ((audioPath[0]=== null || audioPath[0]=== '')) {
            return;
        }
        if (thePlayer.current?.paused) {
            thePlayer.current?.play();
            setIsPlaying(true);
        } else {
            thePlayer.current?.pause();
            setIsPlaying(false);
        }
    };

    const [duration, setDuration]= useState<number>(0);
    const [currentTime, setCurrentTime]= useState<number>(0);

    useEffect(()=>{
        const loadDuration= () => {
            if(thePlayer.current) {
                setDuration(thePlayer.current.duration);
                console.log(thePlayer.current.duration);
            }
        };
        const updateTime= () => {
            if(thePlayer.current) {
                setCurrentTime(thePlayer.current.currentTime);
            }
        };

        if(thePlayer.current) {
            if(audioPath[0]!==null && audioPath[0]!== "") {
                thePlayer.current.load();
            }
            thePlayer.current.addEventListener('loadedmetadata', loadDuration);
            thePlayer.current.addEventListener('timeupdate', updateTime);
        }
        
        return () => {
            if(thePlayer.current){
                thePlayer.current.removeEventListener('loadedmetadata', loadDuration);
                thePlayer.current.removeEventListener('timeupdate', updateTime);
            }
        };
    }, [audioPath]);

    return<>
        <button className={`opacity-[1] hover:opacity-[0.5] ${(audioPath[0]=== null || audioPath[0]=== '') ? 'cursor-not-allowed' : ''}`} onClick={playPause}>
            <img src={!isPLaying ? CirclePlay : CirclePause} alt="PLAY"/>
        </button>
        <div className="w-max">{(audioPath[0]=== null || audioPath[0]=== '') ? "(Pas d'audio)" : `${secondsToMin(currentTime)} / ${secondsToMin(duration)}`}</div>
        <audio controls ref={thePlayer} className="hidden">
            <source src={audioPath[0] || ""} type="audio/ogg"/>
            <source src={audioPath[0] || ""} type="audio/mpeg"/>
        </audio>

        <img src={VerticalDots} alt="DOTS" className="cursor-pointer"/>
    </>;
};

const SQLtoJSfr= (someDate: string) => {//an utility just for converting date formats
    const date = new Date(someDate.replace(' ', 'T'));

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const frenchFormattedDate = `${day}/${month}/${year} à ${hours}:${minutes}:${seconds}`;

    return(frenchFormattedDate);
};

const Banner= () => {
    return <>
        <div className="w-full h-[250px] relative bg-cover bg-center bg-norepeat flex items-center justify-center" style={{ backgroundImage: `url('/freelance-banner.webp')`, backgroundPosition: "center 56%" }}>
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-primary-blue opacity-80 z-1"></div>
            <div className="flex flex-col gap-[8px] items-center justify-center lg:max-w-[943px] max-w-[90vw] mx-auto my-auto relative z-2">
                <h1 className="text-white lg:text-[70px] lg:leading-[84px] text-[40px] leading-[40px] font-semibold">Mon profil <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">worker</span></h1>
            </div>
        </div>
    </>;
};


const ProfileDisplayer = ({data}:any)=>{

    console.log({data})

    const Level = ({level}:any)=>{
        // bg-[#895EF6]
        const [niveau, setNiveau]= useState([1,2,3,4])
        const [selectedLevel,setSelectedLevel] = useState(0)
        

        useEffect(()=>{
            setSelectedLevel(parseInt(level,10))
        }, [data])
    
        console.log(selectedLevel)

        return (
            <>
                <div className="w-full justify-center  flex space-x-[7px]" >
                    {
                        niveau.map((el:any, index: number)=>{
                            return (
                                <div id={el} className={`h-[12px] w-[12px] ${selectedLevel >= el && selectedLevel!==0 ?'bg-[#895EF6]':'bg-[#895EF633]'} rounded-full`} key={"level-bullet-" + index}></div>
                            )
                        })
                    }
                    {/* <div className="h-[12px] w-[12px] bg-[#895EF633]  rounded-full"></div>
                    <div className="h-[12px] w-[12px] bg-[#895EF633]  rounded-full"></div>
                    <div className="h-[12px] w-[12px] bg-[#895EF633]  rounded-full"></div>
                    <div className="h-[12px] w-[12px] bg-[#895EF633]  rounded-full"></div> */}
                </div>
            </>
        )
    }

    return (
        <>
            <div>
                <div className="font-semibold text-[20px] text-[#1D1D39] mb-[20px]">Description</div>
                <div className="font-dm-sans text-[#6F6F6F] mb-[40px]">
                    {data?.description}
                </div>

                <div>
                    <div className="font-bricolage-grotesque font-semibold text-[20px] mb-[20px]">Compétences</div>


                    {
                        data?.expertise_list?.map((el:any, index: number)=>(
                                <div className="h-[93px] w-[471.67px] flex   space-x-[20px] my-[10px]" key={"exp-" + index}>
                                    <div className="relative w-[25px]  before:absolute before:content-['']   before:border before:border-[#F4F4F5] before:transform before:left-1/2 before:top-[33px] before:h-[60px]">
                                        <div className="h-[25px] rounded-full bg-[#F4F4F5] text-[#1D1D39] flex justify-center items-center">{el?.competence.charAt(0).toUpperCase()}</div>
                                    </div>
                                    <div className="font-bricolage-grotesque text-[#6F6F6F] font-normal">
                                        <div className="text-primary-blue font-medium text-[18px] leading-[1] mb-[13px]" style={{fontFeatureSettings: '"cpsp" 1'}}>{el?.competence}</div>
                                        <div className=" mb-[13px]">Expérience : {`${el?.experience} ${el?.experience > 1 ? ' ans':' an'}`}</div>
                                        <div className="flex  space-x-4 items-center">
                                            <div>Niveau : </div>
                                            <div> <Level level={el?.niveau} /></div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        
                    }


                    {/* <div className="h-[93px] w-[471.67px] flex   space-x-[20px] my-[10px]">
                        <div className="relative w-[25px]  before:absolute before:content-['']   before:border before:border-[#F4F4F5] before:transform before:left-1/2 before:top-[33px] before:h-[60px]">
                            <div className="h-[25px] rounded-full bg-[#F4F4F5] text-[#1D1D39] flex justify-center items-center">D</div>
                        </div>
                        <div className="font-bricolage-grotesque text-[#6F6F6F] font-normal">
                            <div className="text-primary-blue font-medium text-[18px] leading-[1] mb-[13px]" style={{fontFeatureSettings: '"cpsp" 1'}}>Développeur web</div>
                            <div className=" mb-[13px]">Expérience : 8 ans</div>
                            <div className="">Niveau : </div>
                        </div> 
                    </div>*/}
                </div>
            </div>
        </>
    )
}

const MainContent= ({profile}:any) => {

    const components = {
        'profile': <ProfileDisplayer data={profile} />,
        'settings': <Settings  data={profile} />
    };

    const [componentName, setComponentName] = useState('profile');
    return <>
        <div className="w-full h-auto bg-white rounded-[0.625rem] md:px-[2.625rem] md:pt-[2.438rem] md:pb-[3.063rem] mt-[21px] md:mt-0 p-[21px] ">
            <div className="flex space-x-8  md:text-[1.25rem] font-bricolage-grotesque mb-[30px]">
                <button className={componentName === 'profile' ? "font-semibold" : "font-semibold text-[#BBBBC4] "} onClick={() => setComponentName('profile')}>Aperçu du profil</button>
                <button className={componentName === "settings" ? "font-semibold" : "font-semibold text-[#BBBBC4]"} onClick={() => setComponentName('settings')}>Paramètres</button>
            </div>

            {/* divider */}
            <Divider />

            {(components as any)[componentName]}
        </div>
    </>;
};


export default Profile;